import { render } from "./RemoteUsersEdit.vue?vue&type=template&id=a073fbce&scoped=true&ts=true"
import script from "./RemoteUsersEdit.vue?vue&type=script&lang=ts"
export * from "./RemoteUsersEdit.vue?vue&type=script&lang=ts"

import "./RemoteUsersEdit.vue?vue&type=style&index=0&id=a073fbce&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a073fbce"]])

export default __exports__